// extracted by mini-css-extract-plugin
export default {"valueProp":"NanoValueProps_valueProp__lG4f9","valuePropHeader":"NanoValueProps_valuePropHeader__Da+lz"};